// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"2bffc004","120":"e32f17c9","346":"dd46b887","357":"ea51e500","439":"bc192fb5","453":"19e60b4e","549":"80e538b3","687":"0223f727","704":"0b9da7d0","983":"91d50460"}[chunkId] + ".chunk.js";
};